
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React from 'react';
import NavButtons from './NavigationButtons';
import Grid from './Grid';
import Auto from './Auto';
import './FindKeypress'
import BtnGameCtrl from './GameMode'
import ScoreBoard from './Score'
import logo from './apple.gif';
import BtnStop from './EndGame';
import GameStatus from './Game_Status'
import LevelSelect from './LevelSelect'


function App() {

  return (
    <div className="app-shell">
      <div className="dreamscape" aria-hidden="true">
        <span className="orb orb-a"></span>
        <span className="orb orb-b"></span>
        <span className="orb orb-c"></span>
      </div>

      <header className="game-header">
        <h1>Eat The Apple <img id="logo" src={logo} alt="" /></h1>
        <p className="tagline">a dreamlike descent through ten levels of temptation</p>
      </header>

      <main className="game-layout">
        <section id="col1" className="grid-panel">
          <div className="grid-frame">
            <Grid/>
          </div>
        </section>

        <aside id="col2" className="control-panel">
          <ScoreBoard/>
          <NavButtons/>
          <div className="game-controls">
            <BtnGameCtrl/>
            <Auto/>
            <BtnStop/>
          </div>
          <LevelSelect/>
        </aside>
      </main>

      <GameStatus/>
    </div>
  );
}


export default App;
